export default __webpack_public_path__ + "static/media/SDG-icon-NL-08.750cb169.svg";